var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h2", [_vm._v("Segmentación")]),
      _c("Spinner", { attrs: { id: "spinner", "is-loading": _vm.isLoading } }),
      !_vm.isLoading
        ? _c(
            "div",
            _vm._l(_vm.riskPoliciesMap, function (value, key, index) {
              return _c(
                "b-collapse",
                {
                  key: index,
                  staticClass: "card",
                  attrs: {
                    animation: "slide",
                    open: _vm.expandedCountry === key,
                  },
                  on: {
                    open: function ($event) {
                      _vm.expandedCountry = key
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "trigger",
                        fn: function (props) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "card-header",
                                attrs: { role: "button" },
                              },
                              [
                                _c("p", { staticClass: "card-header-title" }, [
                                  _vm._v(_vm._s(_vm.countryDictionary[key])),
                                ]),
                                _c("a", { staticClass: "card-header-icon" }, [
                                  _c("span", {
                                    staticClass:
                                      "fa fa-chevron-down transition-fast",
                                    class: { rotate: props.open },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c(
                    "div",
                    { staticClass: "card-content" },
                    _vm._l(value, function (riskPolicy, i) {
                      return _c(
                        "b-collapse",
                        {
                          key: riskPolicy.subSegment,
                          staticClass: "card",
                          attrs: {
                            animation: "slide",
                            open:
                              _vm.expandedRiskPolicySubSegment ===
                              riskPolicy.subSegment,
                          },
                          on: {
                            open: function ($event) {
                              _vm.expandedRiskPolicySubSegment =
                                riskPolicy.subSegment
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "trigger",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "card-header",
                                        attrs: { role: "button" },
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "card-header-title" },
                                          [
                                            _vm._v(
                                              _vm._s(riskPolicy.subSegment) +
                                                " (" +
                                                _vm._s(
                                                  riskPolicy.subSegmentDescription
                                                ) +
                                                ")"
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "a",
                                          { staticClass: "card-header-icon" },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "fa fa-chevron-down transition-fast",
                                              class: { rotate: props.open },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("RiskPolicy", {
                            attrs: { "risk-policy": riskPolicy, country: key },
                            on: {
                              updated: function ($event) {
                                _vm.riskPoliciesMap[key][i] = $event
                              },
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ]
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }